import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/custom.css";
import "./styles/fa.css";
import "./styles/carousel.css";
import React, { lazy, useEffect, Suspense } from "react";


import ScrollToTop from "./ScrollToTop";
import HelperScript from "./utils/helper";

import ReactGA from "react-ga4";
import { marqueeFetchData } from "./redux/actions/marqueeAction";
import { BrowserRouter as Router, Route, Routes, useParams } from "react-router-dom";

import { menuFetchData } from "./redux/actions/menuAction";
import { CityFetchData } from "./redux/actions/cityAction";
import { childmenuFetchData } from "./redux/actions/childmenuAction";
import { tithiFetchData } from "./redux/actions/tithiAction";
import { widgetFetchData } from "./redux/actions/widgetAction";
import { horoscopeFetchData } from "./redux/actions/horoscopeAction";
import { footerFetchData } from "./redux/actions/footerAction";
import { settingFetchData } from "./redux/actions/settingAction";
import { categoryAstroFetchData } from "./redux/actions/categoryAstroAction";
import { useDispatch, useSelector } from "react-redux";
import { menuTabsFetchData } from "./redux/actions/menuTabsActions";

import { addCategoryToCookie } from "./utils/userCookie";
import { fetchTalukaUrls, getTalukaUrlsSync } from "./utils/talukaCache";

const Topbar = lazy(() => import("./components/component/Topbar"));
const ComscoreTracker = lazy(() => import("./ComscoreTracker"));

const EventIndex = lazy(() => import("./components/subcomponents/Event/EventIndex"));
const AllEvents = lazy(() => import("./components/subcomponents/Event/AllEvents"));
const EventDetails = lazy(() => import("./components/subcomponents/Event/EventDetails"));
const EventBooking = lazy(() => import("./components/subcomponents/Event/EventBooking"));
const WebStoryAll = lazy(() => import("./components/subcomponents/WebStoryAll"));
const WebStoryPage = lazy(() => import("./components/subcomponents/WebStoryPage"));
const Games = lazy(() => import("./components/subcomponents/games/games/Games"));
const Status = lazy(() => import("./components/subcomponents/Event/Statues"));
const NewsSearch = lazy(() => import("./components/pages/NewSearch"));
const ScrollPage = lazy(() => import("./components/subcomponents/abc"));
const AstrologyDetailpage = lazy(() => import("./components/subcomponents/astrologycomponent/AstrologyDetailpage"));
const Foryou = lazy(() => import("./components/pages/Foryou"));
const CandidateList = lazy(() => import("./components/subcomponents/PdfPage"));
const RashifalPage = lazy(() => import("./components/subcomponents/astrologycomponent/RashifalPage"));
const LocalBodyEle = lazy(() => import("./components/subcomponents/election/LocalBodyEle"));
const AssemblyEle = lazy(() => import("./components/subcomponents/election/AssemblyEle"));
const EleLocalCMP = lazy(() => import("./components/subcomponents/election/EleLocalCMP"));
const SipCalculator = lazy(() => import("./components/subcomponents/widget/SipCalculator"));
const NewsMakerDetail = lazy(() => import("./components/subcomponents/widget/NewsMakerDetail"));
const Reel = lazy(() => import("./components/subcomponents/reels/Reel"));

const Home = lazy(() => import("./components/pages/Home"));
const Menu = lazy(() => import("./components/subcomponents/Menu"));
const MenuPage = lazy(() => import("./components/subcomponents/MenuPage"));
const BreadCrumb = lazy(() => import("./components/component/BreadCrumb"));
const ScrollButton = lazy(() => import("./components/pages/ScrollButton"));
const Gujarat = lazy(() => import("./components/pages/Gujarat"));
const Rss = lazy(() => import("./components/pages/Rss"));
const Post = lazy(() => import("./components/pages/Post"));
const Sitemap = lazy(() => import("./components/pages/Sitemap"));
const Epaper = lazy(() => import("./components/pages/Epaper/Epaper"));
// jay Ganesha
// jay mataji
const ClippedImage = lazy(
  () => import("./components/pages/Epaper/ClippedImage"),
);
const EpaperCategoryNewsPerDate = lazy(
  () => import("./components/pages/Epaper/EpaperCategoryNewsPerDate"),
);
const Pages = lazy(() => import("./components/pages/Pages"));
const VideosComponent = lazy(
  () => import("./components/pages/VideosComponent"),
);
const PagesInvestorRelation = lazy(
  () => import("./components/pages/PagesInvestorRelation"),
);
const GalleryComponent = lazy(
  () => import("./components/pages/GalleryComponent"),
);
const AstrologyComponent = lazy(
  () => import("./components/pages/AstrologyComponent"),
);
const SearchResult = lazy(() => import("./components/pages/SearchResult"));
const Profile = lazy(() => import("./components/pages/Profile"));
const Maintenance = lazy(() => import("./components/pages/maintenance"));
const Supplement = lazy(() => import("./components/pages/Supplement"));
const VideoCategoryPage = lazy(
  () => import("./components/pages/VideoCategoryPage"),
);
const GujaratMetro = lazy(() => import("./components/pages/GujaratMetro"));
const GujaratSamagra = lazy(() => import("./components/pages/GujaratSamagra"));
const Sport = lazy(() => import("./components/pages/Sport"));
const AssemblyElection = lazy(
  () => import("./components/pages/AssemblyElection"),
);
const GaneshChaturthiPage = lazy(
  () => import("./components/pages/GaneshChaturthiPage"),
);
const Footer = lazy(() => import("./components/subcomponents/Footer"));

const EpaperMenu = lazy(() => import("./components/pages/Epaper/EpaperMenu"));
const TalukaRouteWrapper = lazy(() => import("./components/subcomponents/taluka/TalukaRouteWrapper"));


const extractCategorySlug = (val) => {
  if (!val || typeof val !== "string") return "";
  let s = val.trim().toLowerCase();
  if (s.startsWith("http://") || s.startsWith("https://")) {
    try {
      s = new URL(s).pathname;
    } catch (e) {
      // fallback
    }
  }
  if (s.includes("?")) {
    s = s.split("?")[0];
  }
  return s.replace(/^\/+/, "").replace(/\/+$/, "");
};

const isMenuCategory = (path, menuData) => {
  if (!menuData) return false;
  const normalizedPath = extractCategorySlug(path);
  if (!normalizedPath) return false;

  const search = (items) => {
    if (!items) return false;
    const itemsArray = Array.isArray(items)
      ? items
      : items?.data && (Array.isArray(items.data) || typeof items.data === "object")
        ? (Array.isArray(items.data) ? items.data : Object.values(items.data))
        : Object.values(items);

    for (const item of itemsArray) {
      if (!item) continue;
      const catSlug = extractCategorySlug(item?.category);
      const urlSlug = extractCategorySlug(item?.url);
      const slug = extractCategorySlug(item?.slug);
      const nameSlug = extractCategorySlug(item?.name);
      const titleSlug = extractCategorySlug(item?.title);

      if (
        (catSlug && catSlug === normalizedPath) ||
        (urlSlug && urlSlug === normalizedPath) ||
        (slug && slug === normalizedPath) ||
        (nameSlug && nameSlug === normalizedPath) ||
        (titleSlug && titleSlug === normalizedPath)
      ) {
        return true;
      }
      if (item?.submenu && search(item.submenu)) {
        return true;
      }
      if (item?.sub_category && search(item.sub_category)) {
        return true;
      }
      if (item?.child_menu && search(item.child_menu)) {
        return true;
      }
    }
    return false;
  };

  return search(menuData);
};

const hasItems = (d) => {
  if (!d) return false;
  if (Array.isArray(d)) return d.length > 0;
  if (typeof d === "object") return Object.keys(d).length > 0;
  return false;
};

const CityOrCategoryWrapper = () => {
  const { url } = useParams();
  const dispatch = useDispatch();

  const citiesName = useSelector((state) => state.CityReducer?.data?.data);
  const menuList = useSelector((state) => state.MenuReducer);
  const menuTabsList = useSelector((state) => state.MenuTabsReducer);
  const childmenuList = useSelector((state) => state?.ChildmenuReducer);
  const footerList = useSelector((state) => state?.FooterReducer);

  const cleanUrl = (url || "").toLowerCase();

  const hasCities = hasItems(citiesName);
  const hasMenu = hasItems(menuList?.data);
  const hasMenuTabs = hasItems(menuTabsList?.data);
  const hasChildmenu = hasItems(childmenuList?.data);
  const hasFooter = hasItems(footerList?.data);

  // Lazy check: only verify/fetch talukas if it ends with -news, -taluka, or has no hyphens (potential taluka/city name)
  const isPotentialTaluka = cleanUrl.endsWith("-news") || cleanUrl.endsWith("-taluka") || !cleanUrl.includes("-");

  const [talukaChecked, setTalukaChecked] = React.useState(() => {
    const cachedUrls = getTalukaUrlsSync();
    return !!(cachedUrls || !isPotentialTaluka);
  });

  useEffect(() => {
    const cachedUrls = getTalukaUrlsSync();
    if (cachedUrls) {
      setTalukaChecked(true);
      return;
    }

    if (isPotentialTaluka) {
      fetchTalukaUrls().then(() => {
        setTalukaChecked(true);
      }).catch(() => {
        setTalukaChecked(true);
      });
    } else {
      setTalukaChecked(true);
    }
  }, [cleanUrl, isPotentialTaluka]);

  // Once we resolve what to render, lock it in so re-renders never flip to Post
  const resolvedRef = React.useRef(null);

  // Trigger API fetches dynamically if data is not yet in Redux store
  useEffect(() => {
    if (!hasCities) {
      dispatch(CityFetchData());
    }
    if (!hasMenu) {
      dispatch(menuFetchData());
    }
    if (!hasMenuTabs) {
      dispatch(menuTabsFetchData());
    }
    if (!hasChildmenu) {
      dispatch(childmenuFetchData());
    }
    if (!hasFooter) {
      dispatch(footerFetchData());
    }
  }, [dispatch, hasCities, hasMenu, hasMenuTabs, hasChildmenu, hasFooter]);

  // Reset when the URL param itself changes (user navigated to a different /:url)
  const prevUrlRef = React.useRef(cleanUrl);
  if (prevUrlRef.current !== cleanUrl) {
    prevUrlRef.current = cleanUrl;
    resolvedRef.current = null;

    const cachedUrls = getTalukaUrlsSync();
    if (isPotentialTaluka && !cachedUrls) {
      setTalukaChecked(false);
    } else {
      setTalukaChecked(true);
    }
  }

  // Block rendering of potential taluka pages until cache is loaded/checked
  const cachedUrls = getTalukaUrlsSync();
  if (isPotentialTaluka && !cachedUrls && !talukaChecked) {
    return null;
  }

  // If we already resolved, return the same component
  if (resolvedRef.current === "city") {
    return <GujaratSamagra type="location" />;
  }
  if (resolvedRef.current === "category") {
    return <Gujarat type="category" url={cleanUrl} />;
  }
  if (resolvedRef.current === "post") {
    return <Post />;
  }
  if (resolvedRef.current === "taluka") {
    return <TalukaRouteWrapper />;
  }

  // 1. Check hardcoded special locations (like samagra)
  if (cleanUrl === "samagra") {
    resolvedRef.current = "city";
    return <GujaratSamagra type="location" />;
  }

  // Handle Taluka routing
  if (cleanUrl.endsWith("-taluka-news")) {
    resolvedRef.current = "taluka";
    return <TalukaRouteWrapper />;
  }

  // 2. Check dynamic locations (cities from City API)
  const isCity = citiesName?.some((c) => c.url?.toLowerCase() === cleanUrl);
  if (isCity) {
    resolvedRef.current = "city";
    return <GujaratSamagra type="location" />;
  }

  // Check dynamic talukas (from Taluka API)
  const talukaUrls = getTalukaUrlsSync();
  if (talukaUrls && talukaUrls.has(cleanUrl)) {
    resolvedRef.current = "taluka";
    return <TalukaRouteWrapper />;
  }

  // 3. Check dynamic categories from APIs (web-menu, web-bottom-menu, childmenu, footer-menu)
  const isDynamicCategory =
    isMenuCategory(cleanUrl, menuList?.data) ||
    isMenuCategory(cleanUrl, menuTabsList?.data) ||
    isMenuCategory(cleanUrl, childmenuList?.data) ||
    isMenuCategory(cleanUrl, footerList?.data);
  if (isDynamicCategory) {
    resolvedRef.current = "category";
    return <Gujarat type="category" url={cleanUrl} />;
  }

  // 4. Wait for dynamic API data to load before falling back to Post
  // Never assume it is an article/post until the menu and city APIs have finished loading!
  const isMenuPending = (!hasMenu && !menuList?.hasError && !(Array.isArray(menuList?.error) && menuList?.error?.length));
  const isMenuTabsPending = (!hasMenuTabs && !menuTabsList?.hasError && !(Array.isArray(menuTabsList?.error) && menuTabsList?.error?.length));
  const isCitiesPending = (!hasCities);
  const isStillLoading = isCitiesPending || isMenuPending || isMenuTabsPending || !talukaChecked;
  if (isStillLoading) {
    return null;
  }

  // 5. Default to Post only after all APIs have loaded and confirmed it's not a category
  resolvedRef.current = "post";
  return <Post />;
};

const AstrologyDetailWrapper = () => {
  const { rashi } = useParams();
  // Articles in astrology category have long slugs with hyphens.
  // Rashis are single words (transliterated or Gujarati) or numbers.
  // We use a heuristic: if it has no hyphens or is short, it's likely a rashi.
  const isRashi = !rashi?.includes("-") || rashi?.length < 20;

  if (isRashi) {
    return <AstrologyDetailpage />;
  } else {
    return <Post />;
  }
};

function App() {
  const [mode, setMode] = React.useState("light");
  const [url, setUrl] = React.useState(window.location.href);
  const [sport, setSport] = React.useState(false);
  // const [load, setLoad] = React.useState(false);
  // setTimeout(() => {
  //   setLoad(true);
  // }, [5000]);
  const { 50: sportLayout } = useSelector(
    (state) => state?.SettingReducer?.data,
  );
  const onDarkMode = () => {
    document.documentElement.classList.toggle("dark-mode");
    setMode(mode === "dark" ? "light" : "dark");
  };

  useEffect(() => {
    // Global fix for react-multi-carousel accessibility issue
    // Lighthouse flags: "ARIA hidden element must not be focusable or contain focusable elements"
    const fixCarouselA11y = () => {
      document.querySelectorAll('.react-multi-carousel-item[aria-hidden="true"] a, .react-multi-carousel-item[aria-hidden="true"] button').forEach(el => {
        if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
      });
      document.querySelectorAll('.react-multi-carousel-item[aria-hidden="false"] a, .react-multi-carousel-item[aria-hidden="false"] button').forEach(el => {
        if (el.getAttribute('tabindex') === '-1') el.removeAttribute('tabindex');
      });
    };

    // Run initially and then observe for dynamic carousel changes
    fixCarouselA11y();
    const observer = new MutationObserver(fixCarouselA11y);
    observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    const segments = path.split("/").filter(Boolean);

    // First slug = main category
    const mainCategory = segments[0];

    addCategoryToCookie(mainCategory);
  }, [window.location.pathname]);

  useEffect(() => {
    // Initialize Google Analytics immediately on page load
    ReactGA.initialize("G-6YPHENN7FN", {
      titleCase: false,
    });

    let isInitialized = false;
    const initHeavyTools = async () => {
      if (isInitialized) return;
      isInitialized = true;
      try {
        const Sentry = await import("@sentry/react");
        const { BrowserTracing } = await import("@sentry/tracing");
        Sentry.init({
          dsn: "https://9fbd68e8996640c294f72b3d924bf7cf@o1158838.ingest.sentry.io/6242283",
          integrations: [new BrowserTracing()],
          tracesSampleRate: 1.0,
        });
      } catch (err) {
        console.error("Failed to load Sentry", err);
      }
    };

    const timer = setTimeout(initHeavyTools, 15000);
    const interactionEvents = ['scroll', 'mousemove', 'touchstart'];
    const onInteract = () => {
      initHeavyTools();
      clearTimeout(timer);
      interactionEvents.forEach(e => window.removeEventListener(e, onInteract));
    };
    interactionEvents.forEach(e => window.addEventListener(e, onInteract, { once: true }));

    return () => {
      clearTimeout(timer);
      interactionEvents.forEach(e => window.removeEventListener(e, onInteract));
    };
  }, []);
  useEffect(() => {
    const lang = localStorage.getItem("site_lang");
    if (lang) {
      document.cookie = `googtrans=/en/${lang};path=/`;
    }
  }, []);
  useEffect(() => {
    setInterval(() => {
      setUrl(window.location.href);
    }, 300);
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(settingFetchData());
    dispatch(menuFetchData());
    dispatch(menuTabsFetchData());
    dispatch(childmenuFetchData());
    dispatch(footerFetchData());
    const timer = setTimeout(() => {
      dispatch(tithiFetchData());
      dispatch(widgetFetchData());
      dispatch(horoscopeFetchData());
      dispatch(categoryAstroFetchData());
      dispatch(marqueeFetchData());
    }, 350);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const routeChange = () => { };

  useEffect(() => {
    const toggler = document.querySelector(".navbar-toggler");
    if (toggler) {
      toggler.classList.add("collapsed");
      toggler.setAttribute("aria-expanded", "false");
    }
    const collapse = document.querySelector(".navbar-collapse");
    if (collapse) {
      collapse.classList.remove("show");
    }
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [window.location.href]);


  setTimeout(() => {
    setSport(sportLayout?.value);
  }, 200);



  const isEventPage = window.location.pathname === "/event";
  const appgames = window.location.pathname.startsWith("/appgames");
  const appcalculator = window.location.pathname === "/appcalculator";
  const reel = window.location.pathname === "/reel";
  const webstoryAllMobile = window.location.pathname === "/webstoryAllMobile";
  const status = window.location.pathname.includes("/status");
  const appstockmarket = window.location.pathname === "/app-stockmarket";
  const allEventsPage = window.location.pathname === "/all-events";
  const eventDetailPage = window.location.pathname.includes("/event-detail");
  const eventBookingPage = window.location.pathname.includes("/event-booking");
  const isWebStoryPage = window.location.pathname.startsWith("/webstory/");
  const newsMaker = window.location.pathname.includes('/news-maker')
  const is_search_content =
    window.location.pathname.startsWith("/search-content/");
  const isGujaratElectionLive =
    window.location.pathname === "/gujarat-election-2026-live" ||
    window.location.search.includes("dashboard=true");
  const isGamesInnerPage = ""
  // const isGamesInnerPage = window.location.pathname.startsWith("/games/") && window.location.pathname.length > 7;

  return (
    <>
      {!isGamesInnerPage && (
        <div className="ad-section">
          <meta name="author" content="Sandesh News" />

          <div className="text-center">
            <HelperScript argSmall={187} argLarge={40} />
          </div>
        </div>
      )}
      <Router onChange={routeChange}>
        <ScrollToTop />
        <Suspense fallback={<></>}>
          {!isEventPage &&
            !appgames &&
            !webstoryAllMobile &&
            !reel &&
            !appcalculator &&
            !isWebStoryPage &&
            !appstockmarket &&
            !allEventsPage &&
            !eventDetailPage &&
            !isGujaratElectionLive &&
            !isGamesInnerPage &&
            !eventBookingPage && <Topbar onDarkMode={onDarkMode} mode={mode} />}
          {window.location.href?.includes("/epaper") ? (
            <EpaperMenu />
          ) : (
            <>
              {!isEventPage &&
                !webstoryAllMobile &&
                !appgames &&
                !reel &&
                !appcalculator &&
                !isWebStoryPage &&
                !appstockmarket &&
                !allEventsPage &&
                !eventDetailPage &&
                !isGujaratElectionLive &&
                !isGamesInnerPage &&
                !eventBookingPage &&
                !status && <Menu />}
              {!isEventPage &&
                !appgames && !reel &&
                !appstockmarket &&
                !appcalculator &&
                !webstoryAllMobile &&
                !isWebStoryPage &&
                !allEventsPage &&
                !eventDetailPage &&
                !isGujaratElectionLive &&
                !isGamesInnerPage &&
                !eventBookingPage &&
                !status && <MenuPage />}
              {window.location.href?.includes("/metro") ||
                window.location.href?.includes("/samagra") ||
                window.location.href?.includes("/video/")
                ? ""
                : url?.split("/")?.[4] &&
                !isEventPage && !webstoryAllMobile &&
                !allEventsPage &&
                !eventDetailPage && !reel &&
                !isWebStoryPage &&
                !appcalculator &&
                !newsMaker &&
                !appgames &&
                !eventBookingPage &&
                !isGujaratElectionLive &&
                !isGamesInnerPage &&
                !is_search_content &&
                !status && <BreadCrumb />}
            </>
          )}

          <ComscoreTracker />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />

            <Route exact path="/ScrollPage" element={<ScrollPage />} />

            <Route exact path="/event" element={<EventIndex />} />
            <Route exact path="/status/:slug" element={<Status />} />
            <Route exact path="for-you" element={<Foryou />} />
            <Route exact path="candidate-list" element={<CandidateList />} />
            <Route exact path="games" element={<Games />} />
            <Route exact path="appgames" element={<Games />} />
            <Route exact path="appgames/:gameId" element={<Games />} />
            <Route exact path="games/:gameId" element={<Games />} />
            <Route exact path="gujarat-taluka-news" element={<TalukaRouteWrapper />} />

            <Route exact path="gujarat-election-2026-live" element={<EleLocalCMP />} />
            <Route exact path="local-body-election-2026" element={<LocalBodyEle />} />
            <Route exact path="assembly-election" element={<AssemblyEle />} />
            <Route exact path="rashifal" element={<RashifalPage />} />
            <Route exact path="/webstories" element={<WebStoryAll />} />
            <Route exact path="/webstoryAllMobile" element={<WebStoryAll />} />
            {[
              "/webstory/:path1",
              "/webstory/:path1/:path2",
              "/webstory/:path1/:path2/:path3",
              "/webstory/:path1/:path2/:path3/:path4",
              "/webstory/:path1/:path2/:path3/:path4/:path5",
              "/webstory/:path1/:path2/:path3/:path4/:path5/:path6",
              "/webstory/:path1/:path2/:path3/:path4/:path5/:path6/:path7",
            ].map((path) => (
              <Route path={path} element={<WebStoryPage />} />
            ))}
            <Route exact path="/all-events" element={<AllEvents />} />
            <Route exact path="/event-detail/:id" element={<EventDetails />} />
            <Route exact path="/event-booking/:id" element={<EventBooking />} />
            <Route exact path="/video/:url" element={<VideoCategoryPage />} />
            {/* <Route exact path="/login" element={<Login />} /> */}
            {/* <Route exact path="/world" element={<World />} /> */}
            <Route
              exact
              path="/gujarat/metro"
              element={<GujaratMetro type="location" />}
            />
            <Route exact path="/ahmedabad" element={<GujaratMetro type="location" />} />
            <Route exact path="/surat" element={<GujaratMetro type="location" />} />
            <Route exact path="/rajkot" element={<GujaratMetro type="location" />} />
            <Route exact path="/vadodara" element={<GujaratMetro type="location" />} />
            <Route exact path="/bhavnagar" element={<GujaratMetro type="location" />} />
            <Route exact path="/bhuj" element={<GujaratMetro type="location" />} />
            <Route
              exact
              path="/ganesh-chaturthi/:url"
              element={<GaneshChaturthiPage type="category" />}
            />
            <Route exact path="/:url" element={<CityOrCategoryWrapper />} />
            <Route
              exact
              path="/"
              element={<AssemblyElection type="category" />}
            />

            <Route
              exact
              path="/assembly-elections"
              element={<AssemblyElection type="category" />}
            />
            <Route exact path="/location" element={<Gujarat type="location" />}>
              <Route
                exact
                path=":country"
                element={<Gujarat type="location" />}
              >
                <Route
                  exact
                  path=":state"
                  element={<Gujarat type="location" />}
                >
                  <Route
                    exact
                    path=":city"
                    element={<Gujarat type="location" />}
                  />
                </Route>
              </Route>
            </Route>
            <Route exact path="/epaper" element={<Epaper />} />
            <Route exact path="/epaper/sub" element={<ClippedImage />} />
            <Route exact path="calculator" element={<SipCalculator />} />
            <Route exact path="appcalculator" element={<SipCalculator />} />
            <Route exact path="reel" element={<Reel />} />
            <Route
              exact
              path="/epaper/:city"
              element={<EpaperCategoryNewsPerDate />}
            />
            <Route exact path="/video" element={<VideosComponent />} />
            <Route exact path="/videos" element={<VideosComponent />} />
            {/* <Route exact path="/:url" element={<VideosInnerComponent />} /> */}
            <Route exact path="/page/:id" element={<Pages />} />
            <Route
              exact
              path="/investor-relations"
              element={<PagesInvestorRelation />}
            />
            <Route exact path="/gallery" element={<GalleryComponent />} />
            <Route exact path="/page/rss" element={<Rss />} />
            <Route exact path="/page/sitemap" element={<Sitemap />} />
            {sport === "2" ? (
              <Route
                exact
                path="/t20-world-cup"
                element={<Sport type="category" />}
              />
            ) : (
              ""
            )}
            {/* <Route exact path="/gallery/inner/:url" element={<GalleryInnerComponents />} /> */}
            <Route exact path="/astrology" element={<AstrologyComponent />} />
            {/* <Route
              exact
              path="/astrology/:rashi"
              element={<AstrologyDetailpage />}
            /> */}
            <Route
              exact
              path="/astrology/:rashi/daily"
              element={<AstrologyDetailWrapper />}
            />
            <Route
              exact
              path="/astrology/:rashi/weekly"
              element={<AstrologyDetailWrapper />}
            />
            <Route
              exact
              path="/astrology/:rashi/yearly"
              element={<AstrologyDetailWrapper />}
            />
            <Route
              exact
              path="/astrology/:rashi/tarot"
              element={<AstrologyDetailWrapper />}
            />
            <Route
              exact
              path="/astrology/:rashi"
              element={<AstrologyDetailWrapper />}
            />
            <Route exact path="/supplement" element={<Supplement />} />
            {/* <Route exact path="/astrology/inner" element={<AstrologyInner />} /> */}
            {/* <Route exact path="/location" element={<Location />} /> */}
            <Route exact path="/search" element={<SearchResult />} />
            <Route
              exact
              path="/search-content/:searchValue"
              element={<NewsSearch />}
            />
            <Route
              exact
              path="/news-maker/:value"
              element={<NewsMakerDetail />}
            />
            {/* <Route exact path="/:searchValue" element={<NewsSearch />} /> */}
            {/* <Route exact path="/profile" element={<Profile />} /> */}
            {localStorage.getItem("access_token") && (
              <Route exact path="/profile" element={<Profile />} />
            )}
            <Route exact path="/maintenance" element={<Maintenance />} />
            {[
              "/:path1/:path2",
              "/:path1/:path2/:path3",
              "/:path1/:path2/:path3/:path4",
              "/:path1/:path2/:path3/:path4/:path5",
              "/:path1/:path2/:path3/:path4/:path5/:path6",
              "/:path1/:path2/:path3/:path4/:path5/:path6/:path7",
            ].map((path) => (
              <Route path={path} element={<CityOrCategoryWrapper />} />
            ))}
          </Routes>
          <ScrollButton />
          {!isWebStoryPage && !appcalculator && !appstockmarket && !reel && !isGujaratElectionLive && !isGamesInnerPage && <Footer mode={mode} />}

          {window.location.pathname === "/" ? (
            <>
              <div className="ads_new_styling">
                <div id="ub-banner-h-16"></div>
              </div>
            </>
          ) : (
            ""
          )}
          {/* {!url?.includes('/epaper/sub') && <Footer mode={mode} />} */}
        </Suspense>
      </Router>
    </>
  );
}

export default App;
